import React from 'react';
import { CONTACT_INFO, PIZZERIA_NAME } from '../constants';

const Footer = ({ onNavigate }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-stone-200 bg-[radial-gradient(circle_at_top,_rgba(255,237,213,0.9),_rgba(255,251,245,1)_56%)]">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-10">
        <div className="grid gap-10 lg:grid-cols-[1.3fr_0.9fr]">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.28em] text-orange-700">
              Abschluss mit Substanz
            </p>
            <h3 className="mt-4 text-3xl font-semibold tracking-tight text-stone-950">
              {PIZZERIA_NAME}
            </h3>
            <p className="mt-4 max-w-xl text-base leading-7 text-stone-700">
              Italienischer Genuss ohne Umwege: Steinofen-Pizza, frische Zutaten
              und ein Service, der schnell, klar und freundlich bleibt. Für
              Abholung oder Reservierung erreichst du uns direkt über Telefon
              oder E-Mail.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.28em] text-stone-600">
              Kontakt
            </h4>
            <div className="mt-5 space-y-3 text-base text-stone-700">
              <a
                href={CONTACT_INFO.phoneHref}
                className="block hover:text-orange-700"
              >
                Telefon: {CONTACT_INFO.phone}
              </a>
              <a
                href={CONTACT_INFO.whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                className="block hover:text-orange-700"
              >
                WhatsApp: {CONTACT_INFO.whatsapp || CONTACT_INFO.phone}
              </a>
              <a
                href={CONTACT_INFO.emailHref}
                className="block hover:text-orange-700"
              >
                {CONTACT_INFO.email}
              </a>
              <p>{CONTACT_INFO.addressLines[0]}</p>
              <p>{CONTACT_INFO.addressLines[1]}</p>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-stone-200 pt-6 text-sm text-stone-600 md:flex-row md:items-center md:justify-between">
          <p>
            Copyright {currentYear} {PIZZERIA_NAME}. Alle Rechte vorbehalten.
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <a
              href="/impressum"
              onClick={(event) => {
                event.preventDefault();
                onNavigate('impressum');
              }}
              className="font-semibold text-stone-700 hover:text-orange-700"
            >
              Impressum
            </a>
            <a
              href="/datenschutz"
              onClick={(event) => {
                event.preventDefault();
                onNavigate('datenschutz');
              }}
              className="font-semibold text-stone-700 hover:text-orange-700"
            >
              Datenschutz
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
